export const STATSIG_EXPERIMENTS = {
    CONCIERGE_V1_EXPERIMENT: 'concierge_v1_experiment'
};

export const STATSIG_EXPERIMENTS_DEFAULTS = {
    concierge_v1_experiment: {
        ConciergeViewEnabled: false
    }
};
